module.exports = __webpack_public_path__ + "img/1536790917.3fcb77eb.jpg";